// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
//# sourceMappingURL=IHubProtocol.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aspnet/signalr/dist/esm/IHubProtocol.js
// module id = ./node_modules/@aspnet/signalr/dist/esm/IHubProtocol.js
// module chunks = vendor